var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0013 0.765625H0.830078V26.7091H26.0013V0.765625Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_135_29292",
    transform: "matrix(0.00806973 0 0 0.0078125 -0.0164629 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_135_29292",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAYFBMVEUAAABCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRCgsRcvGdcvGdcvGdcvGdcvGdcvGdcvGdcvGdcvGdcvGdcvGdcvGdcvGdcvGdCgsRcvGcUVwrgAAAAHnRSTlMAEJ/fv49gIFDvz0CvcDCAQCAQj++/n4BwYN9QzzAgEBcOAAAC9klEQVR42u2b6bKiMBCFwyKIOhAR8F5H4f3fckBNWIXuTgJlTc4/KZPzkYQsXWnGIHJcr8TI8/1dEIKqBmkfoeyF/L0m/4Bk3+hw3Na/1m5j/7I8Odv6192wsX9Zuhv7l+UfTf6RD1b/s43Iw6D//j6maOxq6IRB+6MAGAsPqk0w7H8kAGMntVEwGn9oAMcjF53yJ9TS1qHDn/IasgliDf4UgJ0oi12UJucfAkBCBJie/wgAe1E20eBPATiSAD7N/2sBfFx/VgL4vP6tAzCz/q4CMLf+rwEwu/9YAWB+/2MeYGH/ZRxgaf9nGmBx/2kYYHn/axYAsP82CgDZ/5sEAJ0/DALAzj/mAIDnL2MA0PMf4XwDAjgC/csADxB6ywAONP5DOl857iKAC/SnHrKDJYAD0J8cZggWAEz7vwhUASKFIMezlwEAM/EPN8CNP17r3Pldj3MAAOUEPaX0klWNct4+C1YE4C/7RkUqn3qrAfCqo1w+3q0FkGZdgOoqnsdrAVyqvmQnzEzjWgGyAcAPoIxOAD7w74yC/wTgOgSoLIAFsAAWwAJYAAtgASyABbAAFsAEAP+sYgQw8+czCUDEP3ToHUNBAXB99o2eMRQMAFf3HDQCDiDV+/6NriiAi7rhSCkGQH8DNDEUOID2EdAo/yaAXxMAt29qgbMJgALzFeQGADgG4K9+/ztuKi7UHfvKHjiAVHMnZL8Muxxf1V077f9gaACW/uRamuGWF/xV4/dtySyABbAAFsACWAALYApAMR+JDiDvEW0F4AsA1ZwwKoBMhSHcVdMCIJMgvI0A2tt8Srel6ACsvc6HToXRAyD7QL0NaABhC1B6yFtjWgC6TfCckeBZfUIisXQUQ7mBABxcTvGExCxKukVTK6alFXf0rmgUQymAfbdXBRBJ1sNzK4eOHmJqtZSYRQcxlDt8/MZq4+Ak6unFULIHHIA5iRKB+Hq7MZRn/AOhMFHoh/a+oJwL7pj3f+uYnHyfBBC1lTQxlDb+sah/QAGLhe1nTcIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.18694551a8ab3fe011025ce527d233d6.svg";
export { ForwardRef as ReactComponent };